import Styles from './CompanyDataSelect.module.scss'
import { Item } from '@react-stately/collections'
import { OnboardingQuestionOption } from '../CompanyData/utils'
import { AriaLabelingProps } from '@react-types/shared'
import { RefObject } from 'react'
import { SelectProps } from 'components/Select/Types'
import { Select } from 'blaze-ui/Select/Select'

interface Props<T extends string | object>
  extends AriaLabelingProps,
    Omit<SelectProps<T>, 'root' | 'items' | 'children'> {
  onSelect: (key: any) => void
  selectedKey?: string
  options: OnboardingQuestionOption<any>[]
  root?: RefObject<HTMLDivElement>
  backdropClass?: string
  popoverClass?: string
}

export const CompanyDataSelect = <T extends string | object>({
  onSelect,
  options,
  placeholder = 'Select an option',
  root,
  backdropClass,
  popoverClass,
  selectedKey,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  ...selectProps
}: Props<T>) => {
  return (
    <Select
      data-testid="select-button"
      useButtonWidth
      useFullWidth
      ignoreHover
      useChildClass
      popoverClass={popoverClass || Styles.popoverClass}
      onSelectionChange={onSelect}
      spanClass={Styles.spanClass}
      aria-label={ariaLabel}
      placeholder={placeholder}
      variant="secondary"
      root={root?.current}
      backdropClass={backdropClass}
      selectedKey={selectedKey}
      {...selectProps}
    >
      {options?.map((option) => {
        return (
          <Item key={option.value} aria-label={option.title} textValue={option.title}>
            {option.icon && <span className={Styles.svgSpan}>{option.icon}</span>}
            <span>{option.title}</span>
          </Item>
        )
      })}
    </Select>
  )
}
